import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DATIQ_MODAL_BUTTON_ID, IDatiqModal, emptyDatiqModal } from './models';
import { DatiqModalEventsService } from './services';
import {
    IDatiqAnalyticsEvent,
} from '@dat/datiq-core/models';

@Component({
    selector: 'datiq-modal',
    templateUrl: './datiq-modal.component.html',
    styleUrls: ['./datiq-modal.component.scss'],
})
export class DatiqModalComponent implements OnInit {
    @Input()
    settings: IDatiqModal;

    @Output()
    closed: EventEmitter<void> = new EventEmitter<void>();
    @Output()
    clickedCloseButton: EventEmitter<IDatiqAnalyticsEvent> = new EventEmitter<IDatiqAnalyticsEvent>();

    constructor(private _events: DatiqModalEventsService) {}

    ngOnInit(): void {
        this.settings = !!this.settings
            ? {
                  ...this.settings,
              }
            : { ...emptyDatiqModal };

        this._events.opened(this.settings);
    }

    /**
     * This is so that we can eventually target the close button for segment tracking
     */
    clickClose() {
        const analyticsEvent: IDatiqAnalyticsEvent =
            this._events.getAnalyticsButtonClosedButton(this.settings);

        this._events.clickCloseButton(this.settings);
        this.clickedCloseButton.emit(analyticsEvent);
        this.close();
    }

    /**
     * Shared close function to close the actions
     */
    close() {
        this.closed.emit();
    }

    /**
     * Returns a generate string for the close button
     * @returns id of the close button
     */
    closeButtonId(): string {
        return DATIQ_MODAL_BUTTON_ID(this.settings.id);
    }
}
